'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postStartTrackScrollPercentage = undefined;

var _createPostMessageAction = require('../../post-message/actions/createPostMessageAction');

var _PostMessageTypes = require('../../constants/PostMessageTypes');

var postStartTrackScrollPercentage = exports.postStartTrackScrollPercentage = (0, _createPostMessageAction.createPostMessageAction)(_PostMessageTypes.START_TRACK_SCROLL_PERCENTAGE);